import { Link } from "react-router-dom"
import Nav from 'react-bootstrap/Nav'

const CraftRecordNavigation = (props) => {
    return (
        <Nav variant="pills" className="mb-5">
            <Nav.Item>
                {props.currentTab !== "summary"
                    ? <Link to={`/museum/${props.museumId}/documentation/craft-records/${props.craftRecordId}/edit`} className="nav-link no-decoration" disabled={!props.craftRecordId}>
                        Summary
                      </Link>
                    : <Nav.Link active>
                        Summary
                      </Nav.Link>
                }
            </Nav.Item>
            {props.craftRecordId &&
              <>
                <Nav.Item>
                    {props.currentTab !== "video"
                        ? <Link to={`/museum/${props.museumId}/documentation/craft-records/${props.craftRecordId}/edit-video`} className="nav-link no-decoration" disabled={!props.craftRecordId}>
                            Video
                          </Link>
                        : <Nav.Link active>
                            Video
                          </Nav.Link>
                    }
                </Nav.Item>
                <Nav.Item>
                    {props.currentTab !== "context"
                        ? <Link to={`/museum/${props.museumId}/documentation/craft-records/${props.craftRecordId}/edit-context`} className="nav-link no-decoration" disabled={!props.craftRecordId}>
                            Context
                          </Link>
                        : <Nav.Link active>
                            Context
                          </Nav.Link>
                    }
                </Nav.Item>
                <Nav.Item>
                    {props.currentTab !== "person"
                        ? <Link to={`/museum/${props.museumId}/documentation/craft-records/${props.craftRecordId}/edit-person`} className="nav-link no-decoration" disabled={!props.craftRecordId}>
                            Craftsperson
                          </Link>
                        : <Nav.Link active>
                            Craftsperson
                          </Nav.Link>
                    }
                </Nav.Item>
                <Nav.Item>
                    {props.currentTab !== "materials"
                        ? <Link to={`/museum/${props.museumId}/documentation/craft-records/${props.craftRecordId}/edit-materials`} className="nav-link no-decoration" disabled={!props.craftRecordId}>
                            Materials and Tools
                          </Link>
                        : <Nav.Link active>
                            Materials and Tools
                          </Nav.Link>
                    }
                </Nav.Item>
                <Nav.Item>
                    {props.currentTab !== "process"
                        ? <Link to={`/museum/${props.museumId}/documentation/craft-records/${props.craftRecordId}/edit-process`} className="nav-link no-decoration" disabled={!props.craftRecordId}>
                            Process
                          </Link>
                        : <Nav.Link active>
                            Process
                          </Nav.Link>
                    }
                </Nav.Item>
                <Nav.Item>
                    {props.currentTab !== "product"
                        ? <Link to={`/museum/${props.museumId}/documentation/craft-records/${props.craftRecordId}/edit-product`} className="nav-link no-decoration" disabled={!props.craftRecordId}>
                            Product and Distribution
                          </Link>
                        : <Nav.Link active>
                            Product and Distribution
                          </Nav.Link>
                    }
                </Nav.Item>
              </>
            }
        </Nav>
    )
}

export default CraftRecordNavigation